import { render, staticRenderFns } from "./CreateOffer.vue?vue&type=template&id=03e31632&scoped=true&"
import script from "./CreateOffer.vue?vue&type=script&lang=js&"
export * from "./CreateOffer.vue?vue&type=script&lang=js&"
import style0 from "./CreateOffer.vue?vue&type=style&index=0&id=03e31632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e31632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e31632')) {
      api.createRecord('03e31632', component.options)
    } else {
      api.reload('03e31632', component.options)
    }
    module.hot.accept("./CreateOffer.vue?vue&type=template&id=03e31632&scoped=true&", function () {
      api.rerender('03e31632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/CreateOffer.vue"
export default component.exports